export default "__VITE_ASSET__CChklZRF__"